enum GestureAction {
	DOWN = 0,
	SCROLL = 1,
	FLING = 2,
	SHOW_PRESS = 3,
	SINGLE_TAP_UP = 4,
	SINGLE_TAP_UP_CONFIRMED = 5,
	LONG_PRESS = 6,
	DOUBLE_TAP = 7,
	DOUBLE_TAP_EVENT = 8,
}
export default GestureAction;
